import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SyncPastCalls as SyncPastCallsMutation,
    SyncPastCallsVariables,
    SyncPastCallsInput,
    GetSessionUser as GetSessionUserQuery,
} from 'nutshell-graphql-types';

import GET_SESSION_USER from '../../../../core/graphql/queries/get-session-user.graphql';

import SYNC_PAST_CALLS from '../mutations/sync-past-calls.graphql';

export const useSyncPastCalls = (): {
    syncPastCalls: (arg1: SyncPastCallsInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [syncPastCalls, {loading, error}] = useMutation<
        SyncPastCallsMutation,
        SyncPastCallsVariables
    >(SYNC_PAST_CALLS, {
        update: (proxy, mutationResults) => {
            const loggedInUserCache: GetSessionUserQuery | null | undefined = proxy.readQuery({
                query: GET_SESSION_USER,
            });

            if (
                loggedInUserCache &&
                loggedInUserCache.loggedInUser &&
                loggedInUserCache.loggedInUser.phoneIntegrations &&
                mutationResults.data &&
                mutationResults.data.syncPastCalls
            ) {
                const updatedIntegration = mutationResults.data.syncPastCalls.phoneIntegration;

                const updatedIntegrations = loggedInUserCache.loggedInUser.phoneIntegrations.map(
                    (integration) => {
                        if (integration.integrationType === updatedIntegration.integrationType) {
                            return updatedIntegration;
                        }

                        return integration;
                    }
                );

                proxy.writeQuery({
                    query: GET_SESSION_USER,
                    data: {
                        loggedInUser: {
                            ...loggedInUserCache.loggedInUser,
                            phoneIntegrations: updatedIntegrations,
                        },
                    },
                });
            }
        },
    });

    return {
        syncPastCalls: (input: SyncPastCallsInput) => syncPastCalls({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
